'use strict'

angular
  .module('basalteApp')
  .directive('basLight', [
    'BAS_HTML',
    basLightDirective
  ])

/**
 * @param {BAS_HTML} BAS_HTML
 * @returns basLight
 */
function basLightDirective (
  BAS_HTML
) {
  return {
    restrict: 'EA',
    bindToController: {
      light: '<',
      basLights: '<',
      disabled: '<',
      movable: '<'
    },
    controllerAs: 'basLightDir',
    controller: basLightController,
    template: BAS_HTML.light
  }
}

function basLightController () {
  const basLightDir = this

  basLightDir.open = false

  basLightDir.toggleHideGroup = () => {
    if (!basLightDir.disabled) basLightDir.open = !basLightDir.open
  }
}
